import type {TownServiceId} from './worldServices';

/** Visual lane offsets leave the shared service interaction X coordinates unchanged. */
export const TOWN_RESIDENTS:Record<TownServiceId,{height:number;depth:number;phase:number}>={
 trainer:{height:119,depth:-12,phase:0},quest:{height:111,depth:-22,phase:250},
 'skill-reset':{height:116,depth:-16,phase:500},'stat-reset':{height:114,depth:-10,phase:750},
 'class-change':{height:121,depth:-20,phase:1000},merchant:{height:110,depth:-6,phase:1250},
 'pet-vendor':{height:112,depth:-14,phase:1500},'ghost-show':{height:120,depth:-18,phase:1750},
 'ghost-market':{height:116,depth:-18,phase:2000},
 'border-guide':{height:114,depth:-18,phase:2250},
};
